(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-evidence-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!window.evidenceComparisonScrollSyncInitialized) {
    window.evidenceComparisonScrollSyncInitialized = true;
    var scrollPositions = new WeakMap();

    function synchronizeTable(table, position) {
      scrollPositions.set(table, position);
      table.querySelectorAll('.c-evidence-comparison__mobile-scroll').forEach(function (scroller) {
        if (Math.abs(scroller.scrollLeft - position) > 1) {
          scroller.scrollLeft = position;
        }
      });
      var source = table.querySelector('.c-evidence-comparison__mobile-scroll');
      var indicator = table.querySelector('.c-evidence-comparison__mobile-scrollbar');
      var maximum = source.scrollWidth - source.clientWidth;
      indicator.value = maximum > 0 ? Math.round(position / maximum * 1000) : 0;
    }

    document.addEventListener('scroll', function (event) {
      var source = event.target;
      if (!source.matches || !source.matches('.c-evidence-comparison__mobile-scroll')) return;

      var table = source.closest('.c-evidence-comparison__mobile-table');
      if (!table) return;

      if (Math.abs(source.scrollLeft - scrollPositions.get(table)) <= 1) return;
      synchronizeTable(table, source.scrollLeft);
    }, true);

    document.addEventListener('input', function (event) {
      var indicator = event.target;
      if (!indicator.matches('.c-evidence-comparison__mobile-scrollbar')) return;

      var table = indicator.closest('.c-evidence-comparison__mobile-table');
      var source = table.querySelector('.c-evidence-comparison__mobile-scroll');
      var maximum = source.scrollWidth - source.clientWidth;
      synchronizeTable(table, Number(indicator.value) / 1000 * maximum);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-faq-no-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sl-id="sl-section-faq-no-tabs-v1"] .faq__question');
    if (!button) return;

    const answer = document.getElementById(button.getAttribute('aria-controls'));
    if (!answer) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isExpanded));
    answer.hidden = isExpanded;
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[data-sl-id="sl-section-faq-no-tabs-v1"]');
    if (!section) return;

    const button = event.target.querySelector('.faq__question');
    if (!button) return;

    const answer = document.getElementById(button.getAttribute('aria-controls'));
    if (!answer) return;

    button.setAttribute('aria-expanded', 'true');
    answer.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-podcast-ribbon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sl-id="sl-section-podcast-ribbon-v1"]';

    const applyPodcastTitle = (section) => {
      const parameterKey = section.dataset.podcastParam;
      if (!parameterKey) return;

      const podcastTitle = new URLSearchParams(window.location.search).get(parameterKey);
      if (!podcastTitle || !podcastTitle.trim()) return;

      section.querySelectorAll('[data-podcast-title]').forEach((title) => {
        title.textContent = podcastTitle;
      });
    };

    const initialize = (root) => {
      if (root.matches?.(selector)) applyPodcastTitle(root);
      root.querySelectorAll?.(selector).forEach(applyPodcastTitle);
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-promo-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scalingCleanups = new WeakMap();
    const mobileViewport = window.matchMedia('(max-width: 767px)');

    const initializeScaling = (section) => {
      scalingCleanups.get(section)?.();
      const image = section.querySelector('[data-promo-background]');
      if (!image) return;

      const updateScale = () => {
        const baselineHeight = mobileViewport.matches ? 900 : 568;
        const imageHeight = image.naturalWidth > 0 ? image.getBoundingClientRect().height : 0;
        const scale = Math.min(1.5, Math.max(1, imageHeight / baselineHeight));
        section.style.setProperty('--sl-c-promo-hero-scale', String(scale));
      };
      const observer = new ResizeObserver(updateScale);
      observer.observe(image);
      image.addEventListener('load', updateScale);
      image.addEventListener('error', updateScale);
      mobileViewport.addEventListener('change', updateScale);
      updateScale();

      scalingCleanups.set(section, () => {
        observer.disconnect();
        image.removeEventListener('load', updateScale);
        image.removeEventListener('error', updateScale);
        mobileViewport.removeEventListener('change', updateScale);
        section.style.removeProperty('--sl-c-promo-hero-scale');
        scalingCleanups.delete(section);
      });
    };

    const applyUrlOverrides = (section) => {
      const params = new URLSearchParams(window.location.search);
      const backgroundValue = params.get(section.dataset.backgroundParam);
      let backgroundImage = section.querySelector('[data-promo-background]');

      if (backgroundValue) {
        if (!backgroundImage) {
          backgroundImage = document.createElement('img');
          backgroundImage.className = 'c-promo-hero__background-image';
          backgroundImage.alt = '';
          backgroundImage.dataset.promoBackground = '';
          section.querySelector('.c-promo-hero__media')?.append(backgroundImage);
        }

        try {
          const backgroundUrl = new URL(backgroundValue, window.location.href);
          if (backgroundUrl.protocol === 'https:' || backgroundUrl.origin === window.location.origin) {
            backgroundImage.src = backgroundUrl.href;
            backgroundImage.removeAttribute('srcset');
            backgroundImage.removeAttribute('width');
            backgroundImage.removeAttribute('height');
            section.querySelector('.c-promo-hero__placeholder')?.remove();
          }
        } catch {}
      }

      const podcastTitle = params.get(section.dataset.podcastParam);
      if (podcastTitle) {
        section.querySelectorAll('[data-podcast-title]').forEach((title) => {
          title.textContent = podcastTitle;
        });
      }
      initializeScaling(section);
    };

    const initialize = (root) => {
      if (root.matches && root.matches('[data-sl-id="sl-section-promo-hero-v1"]')) {
        applyUrlOverrides(root);
      }
      root.querySelectorAll?.('[data-sl-id="sl-section-promo-hero-v1"]').forEach(applyUrlOverrides);
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-sl-id="sl-section-promo-hero-v1"]').forEach((section) => {
        scalingCleanups.get(section)?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
